'use client'

import { Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import usePrivacyControlCardContent from './usePrivacyControlCardContent'
import PrivacyControlCard from './PrivacyControlCard'

const PrivacyControlSection = () => {
  const translate = useTranslate('privacy_center.control_privacy_section')
  const privacyControlSectionCards = usePrivacyControlCardContent()

  return (
    <section className="privacy-center__control-section">
      <div className="privacy-center__control-content-container">
        <div>
          <h2 className="privacy-center__control-title">{translate('title')}</h2>
          <Text as="div" html>
            <p className="privacy-center__control-subtitle">{translate('subtitle')}</p>
          </Text>
        </div>
        <div className="privacy-center__control-cards-container">
          {privacyControlSectionCards.map((card, index) => (
            <PrivacyControlCard {...card} key={index} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default PrivacyControlSection
